import React from 'react';
import ReactDOM from 'react-dom/client';
import '@design/forma-studio-tokens.css';
import '@design/forma-studio-app-shell.css';
import './app.css';
import { App } from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
